import React from 'react';
import { cn } from '~/lib/utils';
import { Button } from '../ui/button';

type PropType = {
  selected: boolean;
  index: number;
  onClick: () => void;
  children?: React.ReactNode;
  variant: 'full' | 'compact';
};

export const EmblaCarouselThumbButton: React.FC<PropType> = (props) => {
  const { selected, onClick, children } = props;

  return (
    <div
      className={cn(
        'embla-thumbs__slide',
        props.variant == 'compact'
          ? 'min-w-0 flex-[0_0_25%]'
          : 'min-w-0 flex-[0_0_16.6666667%]',
      )}
    >
      <div className="pl-[var(--thumbs-slide-spacing)]">
        <Button
          variant="custom"
          size="custom"
          onClick={onClick}
          type="button"
          className={cn(
            'embla-thumbs__slide__number',
            'group relative flex aspect-square h-auto w-full cursor-pointer touch-manipulation appearance-none !rounded-lg bg-transparent !ring-0 !ring-offset-0',
          )}
        >
          {children}
          <div
            className={cn(
              'pointer-events-none absolute inset-0 flex items-center justify-center rounded-lg border-[1.5px] border-transparent group-focus-visible:border-ring',
              { 'border-primary': selected },
            )}
          />
        </Button>
      </div>
    </div>
  );
};
